<template>
  <!--
          作者：gmshop
          时间：2019-10-25
          描述：单位列表
      -->
  <div class="user">
    <!--搜索表单-->
    <div class="common-seach-wrap">
      <el-form size="small" :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item label="单位名称"><el-input v-model="formInline.unit_name" placeholder="单位名称" style="width:120px"></el-input></el-form-item>


        <el-form-item><el-button type="primary" icon="el-icon-search" @click="onSubmit">查询</el-button></el-form-item>
        <el-form-item><el-button size="small" type="success" @click="onFormat" v-auth="'/unit/unit/format'">导入模板</el-button></el-form-item>
        <el-form-item><el-button type="primary" @click="openUpload" v-auth="'/unit/unit/import'">导入单位</el-button></el-form-item>
      </el-form>
    </div>
    <!--添加单位-->
    <div class="common-level-rail"><el-button size="small" type="primary" icon="el-icon-plus" @click="addClick" v-auth="'/unit/unit/add'">添加单位</el-button></div>

    <!--内容-->
    <div class="product-content">
      <div class="table-wrap">
        <el-table size="small" :data="tableData" border style="width: 100%" v-loading="loading">
          <el-table-column prop="unit_id" label="单位ID" width="60"></el-table-column>

          <el-table-column prop="unit_name" label="单位名称"></el-table-column>

          <el-table-column prop="create_time" label="创建时间" ></el-table-column>
          <el-table-column fixed="right" label="操作" >
            <template slot-scope="scope">
              <el-button @click="editClick(scope.row)" type="text" size="small" v-auth="'/unit/unit/edit'">编辑</el-button>
              <el-button @click="deleteClick(scope.row)" type="text" size="small" v-auth="'/unit/unit/delete'">删除</el-button>
              <el-button @click="groupClick(scope.row)" type="text" size="small" v-auth="'/unit/unit/delete'">团队列表</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>

      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>
    <FileUpload v-if="open_add" :open_add="open_add"  @closeDialog="closeDialogFunc($event, 'add')"></FileUpload>
  </div>
</template>

<script>
import unitApi from '@/api/unit.js';
import qs from 'qs';
import FileUpload from './dialog/FileUpload';
export default {
  components: {
    FileUpload: FileUpload,
  },
  inject: ['reload'],
  data() {
    return {
      /*是否加载完成*/
      loading: true,
      /*列表数据*/
      tableData: [],
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*横向表单数据模型*/
      formInline: {
        unit_name: '',
        unit_number: ''
      },
      /*是否打开添加弹窗*/
      open_add: false,
      /*是否打开编辑弹窗*/
      open_edit: false,
      /*当前编辑的对象*/
      userModel: {}
    };
  },
  created() {
    /*获取列表*/
    this.getTableList();
  },
  methods: {
    /*搜索查询*/
    onSubmit() {
      let self = this;
      self.loading = true;
      self.getTableList();
    },
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getTableList();
    },

    /*每页多少条*/
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },

    /*获取列表*/
    getTableList() {
      let self = this;
      let Params = self.formInline;
      Params.page = self.curPage;
      Params.list_rows = self.pageSize;
      unitApi.unitList(Params, true)
        .then(data => {
          self.loading = false;
          self.tableData = data.data.list.data;
          self.totalDataNumber = data.data.list.total;
        })
        .catch(error => {});
    },

    /*打开添加*/
    addClick() {
      this.$router.push('/unit/unit/add');
    },

    /*打开编辑*/
    editClick(row) {
      let self = this;
      let params = row.unit_id;
      this.$router.push({
        path: '/unit/unit/edit',
        // name: 'mallList',
        query: {
          unit_id: params
        }
      });
    },
    groupClick(row) {
      let self = this;
      let params = row.unit_id;
      this.$router.push({
        path: '/unit/group/index',
        // name: 'mallList',
        query: {
          unit_id: params
        }
      });
    },
    /*删除*/
    deleteClick(row) {
      let self = this;
      self
        .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .then(() => {
          unitApi.deleteUnit(
            {
              unit_id: row.unit_id
            },
            true
          )
            .then(data => {
              self.$message({
                message: '恭喜你，单位删除成功',
                type: 'success'
              });
              self.getTableList();
            })
            .catch(error => {});
        })
        .catch(() => {});
    },
    /*批量导入单位*/
    openUpload() {
      this.open_add = true;
    },
    /*关闭弹窗*/
    closeDialogFunc(e, f) {
      if (f == 'add') {
        this.open_add = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
      if (f == 'edit') {
        this.open_edit = e.openDialog;
        if (e.type == 'success') {
          this.getTableList();
        }
      }
    },
    onFormat: function() {
      let baseUrl = window.location.protocol + '//' + window.location.host;
      window.location.href = baseUrl + '/index.php/shop/unit.unit/format';
    },
  }
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/views/unit/unit/index.vue